import { CloseOutlined } from '@mui/icons-material';
import { Alert, AlertProps, DialogProps, IconButton } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import theme from '@/theme';

import { StyledDialog, StyledDialogActions, StyledDialogContent, StyledDialogTitle } from './StyledDialog';

interface BaseDialogAlertProps {
  isVisible: boolean;
  severity: AlertProps['severity'];
  alertMessage: string;
}
interface BaseDialogProps {
  open: boolean;
  onClose: DialogProps['onClose'];
  title?: string;
  hasCloseButton?: boolean;
  footer: React.ReactNode;
  alert?: BaseDialogAlertProps;
}

function BaseDialog(props: PropsWithChildren<BaseDialogProps>) {
  return (
    <StyledDialog open={props.open} onClose={props.onClose}>
      {props.title && <StyledDialogTitle>{props.title}</StyledDialogTitle>}
      {props.hasCloseButton ? (
        <IconButton
          aria-label='close'
          onClick={(e) => props.onClose?.(e, 'backdropClick')}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseOutlined />
        </IconButton>
      ) : null}
      {props.children ? <StyledDialogContent>{props.children}</StyledDialogContent> : null}
      {props.alert && props.alert.isVisible && (
        <Alert
          severity={props.alert.severity}
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: theme.hhglobal.typography.body.base.fontSize,
            lineHeight: theme.hhglobal.typography.body.base.lineHeight,
          }}
        >
          {props.alert.alertMessage}
        </Alert>
      )}
      {props.footer ? <StyledDialogActions>{props.footer}</StyledDialogActions> : null}
    </StyledDialog>
  );
}

export default BaseDialog;
